export default "__VITE_ASSET__evBxXSsy__"